/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 *
 ********************************************************************!*/

import MdMenu from "./MdMenu.vue";
import TransitionMdMenu from "./TransitionMdMenu.vue";

export { MdMenu, TransitionMdMenu };

export interface IMenuItem {
  icon?: string;
  label: string;
  value: string | number;
  subMenu?: IMenuItem[];
}
